<template>
  <v-data-table
    :headers="headers"
    :items="items"
    disable-pagination
    hide-default-footer			
    class="tablaLT1"
    :class="dark_t?'dark':''">
    <template v-slot:no-data>
        <v-icon>warning</v-icon>
        Sin Información.
    </template>
  </v-data-table>

</template>

<script>
export default {
  props:['items'],
  data() {
    return {
    headers:[
        { text: 'Nombre', value: 'employee_name'},
        { text: 'Cargo', value: 'position_name'},
        { text: 'Área', value: 'area_name'},
      ]
    };
  },
};
</script>
